import React, { useEffect, useMemo, useCallback, useRef } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Box
} from '@mui/material';
import { Page, Header, MapGeneric, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import L from 'leaflet';
import _ from 'underscore';
import { enqueueSnackbar } from 'actions';
import { onUpdateLegend } from 'components/Map/actions/MapActions';
import {
	SetFormState, ResetFields,
	ToggleSummaryDialog, GetSitesIds, GetTopology2g, GetTopology3g, GetTopology4g,
	GetTopologyLabels2g, GetTopologyLabels3g, GetTopologyLabels4g
} from '../actions/MapDriveTestsActionsGeneric';
import TopToolBarGeneric from './components/TopToolBarGeneric';
import SideFiltersGeneric from './components/SideFiltersGeneric';
import SummaryDialogGeneric from './components/Components/SummaryDialogGeneric';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const MapDriveTestsGeneric = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));

	// Map
	const maps = useSelector(state => state.mapReducerGeneric.maps);
	const formState = useSelector((state) => state.mapDriveTestsReducerGeneric.formState);
	const mapOne = maps.filter(item => item.id === 'failures-map')[0];
	const siteIdLocation = useSelector(state => state.mapDriveTestsReducerGeneric.siteIdLocation);
	const topology2gData = useSelector(state => state.mapDriveTestsReducerGeneric.topology2gData);
	const topology3gData = useSelector(state => state.mapDriveTestsReducerGeneric.topology3gData);
	const topology4gData = useSelector(state => state.mapDriveTestsReducerGeneric.topology4gData);
	const topologyLabels2gData = useSelector(state => state.mapDriveTestsReducerGeneric.topologyLabels2gData);
	const topologyLabels3gData = useSelector(state => state.mapDriveTestsReducerGeneric.topologyLabels3gData);
	const topologyLabels4gData = useSelector(state => state.mapDriveTestsReducerGeneric.topologyLabels4gData);

	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const summaryDialogVisibility = useSelector((state) => state.mapDriveTestsReducerGeneric.summaryDialogVisibility);

	const _getData = useCallback(() => {
		dispatch(GetSitesIds());
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const makeDetailsSiteId = (item) => {
		const table = `<table class="table table-striped">
						<tr>
						<th>SiteId: </th>
						<td>${item.siteId}</td>
						</tr>
						<tr>
						<th>Latitude: </th>
						<td>${item.latitude}</td>
						</tr>
						<tr>
						<th>Longitude: </th>
						<td>${item.longitude}</td>
						</tr>
					</table>`;
		return table;
	};

	const _addSiteLocation = (map, data, layerName, flyTo) => {
		map.RemoveLayerById(layerName);
		const markers = [];

		const packetIcondrop = L.icon({
			iconUrl: 'images/leaflet/marker-icon.png',
			// iconSize: [35, 35], // size of the icon
			iconAnchor: [13, 40], // point of the icon which will correspond to marker's location
			popupAnchor: [0, -38] // point from which the popup should open relative to the iconAnchor
		});

		if (!_.isEmpty(data)) {
			const marker = L.marker([data.latitude, data.longitude], { title: data.failureId, icon: packetIcondrop });
			markers.push(marker.bindPopup(`<br>${makeDetailsSiteId(data)}<br>`, { autoPan: false }));

			if (flyTo) {
				map.mapContext.map.flyTo([data.latitude, data.longitude], 12);
			}
		}

		const layer = L.layerGroup(markers, { id: layerName });
		layer.addTo(map.mapContext.map);
	};

	useMemo(() => {
		if (mapOne) {
			_addSiteLocation(mapOne.control, siteIdLocation, 'siteIdLocation', true);
		}
	}, [siteIdLocation]);

	useMemo(() => {
		if (mapOne) {
			setTimeout(() => { mapOne.control.mapContext.map.invalidateSize(); }, 100);
		}
	}, [formState.values.mapFilters]);

	const _summaryDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleSummaryDialog(false));
		}
	};

	return (
		<Page className={classes.root} title="Map">
			<Header module="Modules" view="Map" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardContent>
						{/* <Grid container spacing={2}>
							<Grid item md={12}>
								<TopToolBar />
							</Grid>
						</Grid> */}
						<Grid container spacing={2}>
							<Grid item md={formState.values.mapSize}>
								<MapGeneric id="failures-map" scale height="70vh" />
							</Grid>
							<Grid item md={2} xs={2} hidden={!formState.values.mapFilters}>
								<SideFiltersGeneric height="70vh" />
							</Grid>
						</Grid>
					</CardContent>
				</Card>
				{summaryDialogVisibility && (
					<SummaryDialogGeneric
						onClose={_summaryDialogClose}
						open={summaryDialogVisibility}
					/>
				)}
			</div>
		</Page>
	);
};

export default MapDriveTestsGeneric;
